import React from "react";
import { connect } from "react-redux";
import { selectFeatureFlag } from "redux/modules/lenndFlags/selectors";

// Creates an object of feature flags from an array of flag names
const createFlagsObject = (state, flags) => {
  return flags.reduce((acc, flag) => {
    acc[flag] = selectFeatureFlag(flag)(state);
    return acc;
  }, {});
};

// HOC that injects feature flags as props
export const injectFeatureFlags = flags => WrappedComponent => {
  const WithFeatureFlags = props => {
    return <WrappedComponent {...props} featureToggles={props.featureFlags} />;
  };

  const mapStateToProps = state => ({
    featureFlags: createFlagsObject(state, flags)
  });

  return connect(mapStateToProps)(WithFeatureFlags);
};

export default injectFeatureFlags;
